export function escapeHTML(unsafe: string) {
  // https://pablotron.org/2022/03/09/fastest-js-html-escape/
  return unsafe
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll("'", '&apos;')
    .replaceAll('"', '&quot;');
}
